import React from "react"

function Navbar() {
    return(
        <nav class="navbar navbar-expand-lg navbar-light bg-white">
            <div class="container">
                <a class="navbar-brand" href="./index.html">
                <h1 class="display-3 text-center text-md-left" style={{fontSize: '3.5rem'}}>
                    <span style={{ color: '#335eea', fontWeight: 'bold' }}>Delta</span> Parse
                </h1>
                </a>
            </div>
        </nav>
    )
}

export default Navbar
